import React from 'react';
import { IContentLibCategoryListProps } from './types';
import { Button, Stack } from '@mui/material';
import { theme } from '../../../../../../common/styles/theme';

export const ContentLibCategoryList: React.FC<IContentLibCategoryListProps> = ({
	selectedCategoryId,
    categories,
	onCategorySelect
}) => {

	const buttons = [
		...[{id: 0, name: 'All'}],
		...categories
	]
	
	return (
		<Stack
			direction={'row'}
			alignItems={'center'}
			gap={.5}
			sx={{
				mt: theme.spacing(2),
			}}
		>
			{buttons.map((category) => {
				return (
					<Button
						className={`${selectedCategoryId === category.id ? 'active' : ''}
							${!category.id ? 'all' : ''}
						`}
						variant={'contained'}
						sx={{
							height: theme.spacing(3.5),
							p: theme.spacing(.25, 1),
							textTransform: 'capitalize',
							color: theme.palette.grey[600],
							background: 'transparent',
			
							'&:hover': {
								color: theme.palette.grey[900],
								background: theme.palette.grey[50],
							},

							'&.all': {
								color: theme.palette.grey[900],
								fontWeight: 600,
							},

							'&.active': {
								color: theme.palette.common.white,
								background: theme.palette.primary.main,
							}
						}}
						onClick={() => onCategorySelect(category.id)}
						key={`category-${category.id}`}
					>
						{category.name}
					</Button>
				)
			})}
		</Stack>
	);
};
